import React, { Component } from 'react';
import {Helmet} from 'react-helmet'

import { Container, Col, Row, Button } from 'react-bootstrap';

import HeroImage from '../components/HeroImage';
import NavBar from '../components/NavBar';
import ParticipatingSchools from '../components/ParticipatingSchools';

export default class Home extends Component {
    render() {
        return (
            <div>
                <Helmet>
                    <title>ISSC</title>
                </Helmet>
                <NavBar hasHero={true} />
                <HeroImage backgroundImage="https://firebasestorage.googleapis.com/v0/b/issc-vn.appspot.com/o/images%2Fclub_photo.JPG?alt=media&token=76a85ae7-9aed-40ad-9009-135f88377f7d" />
                <br />
                <Container>
                    <Row>
                        <Col>
                            <h2>Who We Are</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <p>
                                We are the organizers of the International School Science Competition, and we work purely 
                                to create the cornerstone for the community’s science students to expand their knowledge 
                                outside of school and creatively utilize their knowledge to collaboratively produce creative 
                                student initiated products.
                            </p>
                            <p>
                                The purpose of the competition is to provide opportunities for enthusiastic science 
                                students to collaborate and create student-made products. This opportunity would help 
                                students to expand their knowledge on science-related subjects that they either know well 
                                or know nothing about proposed by a team of organizers. In addition, hopefully this would 
                                benefit the local community to develop their scientific knowledge as well.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <h2>Participating Schools</h2>
                        </Col>
                    </Row>
                    <ParticipatingSchools schools={[
                        ["https://firebasestorage.googleapis.com/v0/b/issc-vn.appspot.com/o/images%2Fschool_logos%2Fssis_logo.png?alt=media&token=cd219c2a-9b30-4b57-9306-af307d3deacf", "https://www.ssis.edu.vn/", "SSIS", true],
                        ["https://firebasestorage.googleapis.com/v0/b/issc-vn.appspot.com/o/images%2Fschool_logos%2Fabcis_logo.png?alt=media&token=df837bc1-aba3-4c75-ba38-696514053097", "http://www.theabcis.com/", "ABCIS"],
                        ["https://firebasestorage.googleapis.com/v0/b/issc-vn.appspot.com/o/images%2Fschool_logos%2Fbis_logo.png?alt=media&token=9e08ded8-5272-47ee-b27b-cf056b1e61f8", "https://www.nordangliaeducation.com/our-schools/vietnam/ho-chi-minh-city/bis", "BIS"],
                        ["https://firebasestorage.googleapis.com/v0/b/issc-vn.appspot.com/o/images%2Fschool_logos%2Fishmic_logo.png?alt=media&token=eac8a469-2521-4059-b7ea-9f4d56c3590f", "https://www.ishcmc.com/", "ISHMIC"],
                        ["https://firebasestorage.googleapis.com/v0/b/issc-vn.appspot.com/o/images%2Fschool_logos%2Fris_logo.jpg?alt=media&token=ffe3a12d-cbbb-44f4-8afd-e69e74094dfe", "https://www.renaissance.edu.vn/", "RIS"]
                    ]} />
                    <Row>
                        <Col>
                            <h2>Competition Information</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="5" md="5">
                            <iframe title="Map to SSIS" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10562.699982849173!2d106.70487481602783!3d10.723311352860655!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752fed23d40635%3A0x752d993fbb042eef!2zNzggTmd1eeG7hW4gxJDhu6ljIEPhuqNuaCwgVMOibiBQaG9uZywgUXXhuq1uIDcsIEjhu5MgQ2jDrSBNaW5oLCBWaWV0bmFt!5e0!3m2!1sen!2s!4v1570447204437!5m2!1sen!2s" width="100%" height="300px" frameBorder="0" style={{border: 0}} allowFullScreen=""></iframe>
                            <br />
                            <br />
                        </Col>
                        <Col>
                            <h4>When</h4>
                            <p>2019 November 15-16</p>
                            <h4>Where</h4>
                            <p>Saigon South International School</p>
                            <br />
                            <Button style={{marginBottom: "2em"}} variant="dark" href="/contact">Contact Us</Button>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }
}
